interface Rect { left: number; right: number; top: number; bottom: number }
/** The narrow physical gap between the observed anchor and its adjacent preview. */
export function withinPreviewBridge(x: number, y: number, anchor: Rect, preview: Rect): boolean {
  if (![x, y, ...Object.values(anchor), ...Object.values(preview)].every(Number.isFinite)) return false;
  const vertical = y >= Math.min(anchor.top, preview.top) && y <= Math.max(anchor.bottom, preview.bottom);
  if (preview.left >= anchor.right && preview.left - anchor.right <= 24)
    return vertical && x >= anchor.right && x <= preview.left;
  if (anchor.left >= preview.right && anchor.left - preview.right <= 24)
    return vertical && x >= preview.right && x <= anchor.left;
  const horizontal = x >= Math.min(anchor.left, preview.left) && x <= Math.max(anchor.right, preview.right);
  if (preview.top >= anchor.bottom && preview.top - anchor.bottom <= 24)
    return horizontal && y >= anchor.bottom && y <= preview.top;
  if (anchor.top >= preview.bottom && anchor.top - preview.bottom <= 24)
    return horizontal && y >= preview.bottom && y <= anchor.top;
  return false;
}
